import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbPopoverModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { I18nModule } from '../../../core/i18n';
import { IconThemeReverseModule } from '../../directives';
import { PipesModule } from '../../pipes/pipes.module';
import { GenericLinkModule } from '../generic-link';
import { SearchFieldModule } from '../search-field';
import { SpinnerModule } from '../spinner';
import { AddToAreaOfUseComponent } from './add-to-area-of-use.component';

@NgModule({
  declarations: [AddToAreaOfUseComponent],
  imports: [
    CommonModule,
    I18nModule,
    NgbPopoverModule,
    NzIconModule,
    InfiniteScrollModule,
    SpinnerModule,
    GenericLinkModule,
    NgbTooltipModule,
    SearchFieldModule,
    PipesModule,
    IconThemeReverseModule,
  ],
  exports: [AddToAreaOfUseComponent],
})
export class AddToAreaOfUseModule {}
